import React from "react";
import { Flex, FlexProps, Spinner } from "@chakra-ui/react";

interface Props extends FlexProps {
  size?: number;
}

function CenteredSpinner({ size = 30, ...props }: Props) {
  return (
    <Flex
      justifyContent={"center"}
      alignItems={"center"}
      width={"100%"}
      height={"100%"}
      {...props}
    >
      <Spinner color={"#1272EF"} width={`${size}px`} height={`${size}px`} />
    </Flex>
  );
}

export default CenteredSpinner;
